import { ComponentFactory, ComponentFactoryResolver, ComponentRef, Injectable, OnChanges, SimpleChange, SimpleChanges, Type, ViewContainerRef } from '@angular/core';
import { IObject } from '../../../type_definitions/datatypes';
import * as _ from 'underscore';

@Injectable()
export class ComponentService {
  constructor(
    private componentFactoryResolver:ComponentFactoryResolver
  ) {
  }

  public createComponent<T>(viewContainerRef:ViewContainerRef, componentClass:Type<T>, inputs:IObject):ComponentRef<T> {
    const componentFactory:ComponentFactory<T> = this.componentFactoryResolver.resolveComponentFactory(componentClass);

    viewContainerRef.clear();
    const componentRef:ComponentRef<T> = viewContainerRef.createComponent(componentFactory);

    if(!_.isEmpty(inputs)){
      // TODO from angular 14 we need to use https://v14.angular.io/api/core/ComponentRef#setInput, it will make sure ngOnChanges is called
      const changes:SimpleChanges = {};
      _.each(inputs, (val:any, key:string) => {
        componentRef.instance[key] = val;
        changes[key] = new SimpleChange(undefined, val, true);
      });
      if ((<OnChanges><any>componentRef.instance).ngOnChanges) {
        (<OnChanges><any>componentRef.instance).ngOnChanges(changes);
      }
    }

    return componentRef;
  }
}